var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{ref:"masterMain",attrs:{"addProperties":{
    eventType: 1,
    routeToCreate: _vm.getModuleRoute,
  },"exportProperties":{
    pdf: {
      filename: `${_vm.$t('common_words.category_record')}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t('common_words.category_record')}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  },"route":_vm.getModuleRoute,"tableProperties":_vm.tableProperties,"showSubcategories":true,"dataBadges":[
    {
      columnLabel: _vm.$t('common_words.sub_category'),
      data: 'subcategories',
      property: 'name',
      minWidth: 250,
    },
  ]},on:{"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}})
}
var staticRenderFns = []

export { render, staticRenderFns }